//Auth API functions
import axios from "axios";
import { baseUrl } from "@/Base_url";
import axiosInstance from "@/utils/axios";

// ==================== AUTH APIs ====================
export const superadminLoginApi = async (payload) => {
    const response = await axios.post(`${baseUrl}/api/auth/superadmin/login`, {
        email: payload.email,
        
      });
    
    return response.data; 
};

export const superadminVerifyApi = async (payload) => {
    const response = await axios.post(`${baseUrl}/api/auth/superadmin/login`, {
        email: payload.email,
        otp: payload.otp,
      });
    
    return response.data; 
};

export const sendOtp = async (payload) => {
    const response = await axios.post(`${baseUrl}/api/auth/send-otp`, {
        phone:payload.phone,
      });
    
      return response.data; 
};

export const emailSendOtp = async (payload) => {
    const response = await axios.post(`${baseUrl}/api/auth/send-otp`, {
        email: payload.email,
      });
    
      return response.data; 
};

export const verifyOtp = async (payload) => {
    const response = await axios.post(`${baseUrl}/api/auth/verify-otp` , {
        phone:payload.phone,
        otp:payload.otp
    })
    return response.data;
}

export const emailVerifyOtp = async (payload) => {
    const response = await axios.post(`${baseUrl}/api/auth/verify-otp` , {
        email: payload.email,
        otp: payload.otp
    })
    return response.data;
}

export const logout = async () => {
    const response = await axiosInstance.post(`${baseUrl}/api/auth/logout`);
    return response.data;
}

// ==================== Profile APIs ====================

export const getProfile = async () => {
    const response = await axiosInstance.get(`${baseUrl}/api/login/profile`);
    return response.data;
}
